import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, styled, Typography } from '@mui/material';

const HighlightedBox = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
  color: '#FFF',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  overflowX: 'auto',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all'
}));

interface CodeSnippetProps {
  embedScript: string;
}

function CodeSnippet({ embedScript }: CodeSnippetProps): React.ReactElement {
  const [showCopiedMessage, setShowCopiedMessage] = useState<boolean>(false);

  const handleCopy = (text: string, result: boolean): void => {
    if (result) {
      setShowCopiedMessage(true);
      setTimeout(() => {
        setShowCopiedMessage(false);
      }, 3000);
    }
  };
  return (
    <div style={{ position: 'relative' }}>
      <HighlightedBox>
        <code>{embedScript}</code>
        <CopyToClipboard text={embedScript} onCopy={handleCopy}>
          <IconButton sx={{ paddingX: 0 }} aria-label='Copy script'>
            <ContentCopyIcon sx={{ color: '#FFF' }} />
          </IconButton>
        </CopyToClipboard>
      </HighlightedBox>
      {showCopiedMessage && (
        <Typography
          variant='body2'
          sx={{
            position: 'absolute',
            right: 0,
            top: '100%',
            marginTop: '0.25rem',
            fontWeight: 'bold'
          }}
        >
          Copied!
        </Typography>
      )}
    </div>
  );
}

export default CodeSnippet;
